export default __webpack_public_path__ + "static/media/email-envelope.f66eff41.svg";